function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getLoginUrl } from '../helpers/config';
import handleFetchErrors from '../helpers/handleFetchErrors';
const handle401 = response => {
  if (response.status === 401) {
    return response.json().then(e => {
      if (e.status) {
        throw e;
      }
      throw _objectSpread(_objectSpread({}, e), {}, {
        status: response.status
      });
    });
  }
  return response;
};
const getReferrerUrl = () => {
  let urlParams = '';
  const location = window.location;
  let {
    href: currentUrl
  } = location;
  const {
    search
  } = location;
  const searchParams = new URLSearchParams(search);
  if (!searchParams.has('referrer_url') && document.referrer) {
    searchParams.append('referrer_url', document.referrer);
    urlParams = '?' + searchParams.toString();
    currentUrl = search ? currentUrl.replace(search, urlParams) : currentUrl + urlParams;
  }
  return currentUrl;
};
export const fetchToken = () => {
  const currentUrl = getReferrerUrl();
  const url = "".concat(getLoginUrl(), "/api/v1/authentication/refresh?currentUrl=").concat(encodeURIComponent(currentUrl));
  return fetch(url, {
    credentials: 'include'
  }).then(handle401).then(handleFetchErrors).then(res => res.json());
};
//# sourceMappingURL=fetchToken.js.map